module.exports = __webpack_public_path__ + "img/store-teaser.c1424a0c.jpg";